import { render, staticRenderFns } from "./libraryEditForm.vue?vue&type=template&id=504daa04"
import script from "./libraryEditForm.vue?vue&type=script&lang=js"
export * from "./libraryEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports